export const cardOptionsLabels = {
  option_loyalty_program: 'entity.card.item.options.option_loyalty_program',
  option_bonuses: 'entity.card.item.options.option_bonuses',
  option_cashback: 'entity.card.item.options.option_cashback',
  option_online_payments: 'entity.card.item.options.option_online_payments',
  option_wireless_payments: 'entity.card.item.options.option_wireless_payments',
  option_sms_notifications: 'entity.card.item.options.option_sms_notifications',
  option_salary_project: 'entity.card.item.options.option_salary_project',
  option_online_banking: 'entity.card.item.options.option_online_banking',
  option_overdraft: 'entity.card.item.options.option_overdraft'
}
